import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/objectWithoutPropertiesLoose";
var _excluded = ["children", "layout"];
import React from "react";
import { BlockMath, InlineMath } from "react-katex";
import { jsx as _jsx } from "react/jsx-runtime";
export var MathML = _ref => {
  var {
    children,
    layout = "inline"
  } = _ref,
      rest = _objectWithoutPropertiesLoose(_ref, _excluded);

  return /*#__PURE__*/_jsx("div", _extends({}, rest, {
    className: "text-foreground " + layout,
    children: layout === "inline" ? /*#__PURE__*/_jsx(InlineMath, {
      children: children
    }) : /*#__PURE__*/_jsx(BlockMath, {
      children: children
    })
  }));
};
//# sourceMappingURL=mathml.js.map